"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetExtendedContactDetailsAllOfStatisticsUnsubscriptionsAdminUnsubscription {
    static getAttributeTypeMap() {
        return GetExtendedContactDetailsAllOfStatisticsUnsubscriptionsAdminUnsubscription.attributeTypeMap;
    }
}
GetExtendedContactDetailsAllOfStatisticsUnsubscriptionsAdminUnsubscription.discriminator = undefined;
GetExtendedContactDetailsAllOfStatisticsUnsubscriptionsAdminUnsubscription.attributeTypeMap = [
    {
        "name": "eventTime",
        "baseName": "eventTime",
        "type": "string"
    },
    {
        "name": "ip",
        "baseName": "ip",
        "type": "string"
    }
];
exports.GetExtendedContactDetailsAllOfStatisticsUnsubscriptionsAdminUnsubscription = GetExtendedContactDetailsAllOfStatisticsUnsubscriptionsAdminUnsubscription;
//# sourceMappingURL=getExtendedContactDetailsAllOfStatisticsUnsubscriptionsAdminUnsubscription.js.map